export default __webpack_public_path__ + "static/media/switch-red-hover.00c07fec.svg";